import { useAppSelector } from "../../app/appHooks";
import { CommunityTypes, RoleTypes } from "../../../helpers/constants";
import { IRoleTypes } from "../../../services/header.services";

// Returns the role list for the role picker, ordered and normalized to the
// community type:
// - PRO: admin, caregiver, pro:family, installer
// - AIP: admin, family, caregiver
const ROLE_ORDER_PRO = [
  RoleTypes.admin,
  RoleTypes.caregiver,
  RoleTypes.pro_family,
  RoleTypes.installer,
];

const ROLE_ORDER_AIP = [RoleTypes.admin, RoleTypes.family, RoleTypes.caregiver];

const buildOrderedRoles = (
  roles: IRoleTypes[],
  order: string[]
): IRoleTypes[] => {
  const familyRole = roles.find(
    (role) =>
      role.name === RoleTypes.family || role.name === RoleTypes.pro_family
  );
  return order
    .map((name) => {
      if (
        (name === RoleTypes.family || name === RoleTypes.pro_family) &&
        familyRole !== undefined
      ) {
        return { ...familyRole, name };
      }
      return roles.find((role) => role.name === name);
    })
    .filter((role): role is IRoleTypes => role !== undefined);
};

export const useFilteredUserRoles = () => {
  return useAppSelector((state) => {
    const communityType = state.headerState.selectedCommunity?.community_type;
    if (communityType === undefined) return undefined;
    if (state.headerState.userRoles === undefined) return undefined;

    if (communityType === CommunityTypes.pro) {
      return buildOrderedRoles(state.headerState.userRoles, ROLE_ORDER_PRO);
    } else if (communityType === CommunityTypes.aip) {
      return buildOrderedRoles(state.headerState.userRoles, ROLE_ORDER_AIP);
    }
    return state.headerState.userRoles;
  });
};
